<template>
  <div>
    <b-row>
      <b-col md="3">
        <filters @refresh="filterChanged" @clearFilter="clearFilter" />
      </b-col>

      <b-col md="9">
        <b-card>
          <div class="d-flex justify-content-between align-items-end">
            <b-form-group :label="$t('generals.search') + ':'">
              <b-form-input
                id="search"
                v-model="params.search"
                @input="delayedFilter"
              />
            </b-form-group>
            <div>
              <b-button
                v-if="checkPermission('finance-export')"
                variant="success"
                class="mb-1 mr-1"
                @click="exportExcel"
              >
                <feather-icon icon="ArrowUpIcon" />
                {{ $t('generals.export') }}
              </b-button>
              <b-button
                v-if="checkPermission('finance-import')"
                variant="success"
                class="mb-1 mr-1"
                @click="openFileUploadModal"
              >
                <feather-icon icon="ArrowDownIcon" />
                {{ $t('generals.import') }}
              </b-button>
              <b-button
                v-if="checkPermission('finance-add')"
                variant="info"
                class="mb-1"
                @click="isSidebar = true"
              >
                {{ $t('generals.add') }}
              </b-button>
            </div>
          </div>
          <TableOperations
            v-if="checkPermission('finance-list')"
            :params="params"
            @add-button-clicked="modalShow"
            @editOperation="editOperation"
            @pageChanged="changePage"
            @showQrCode="showQrCode"
            @showClick="showClick"
            @deleteClick="deleteClick"
          />
        </b-card>
      </b-col>
    </b-row>

    <OperationsModal
      :operation="operation"
      :admission="true"
      :is-show-modal.sync="isSidebar"
      @updated="updateTable"
    />
    <file-upload-modal />
    <qr-code-modal :photo="qr_url" />
    <show-file-modal :url="receipt_url" />
  </div>
</template>

<script>
import {
  BRow,
  BCol,
  VBToggle,
  BFormGroup,
  BFormInput,
  BButton,
  BCard,
} from 'bootstrap-vue'
import { mapActions, mapGetters } from 'vuex'
import FileUploadModal from './components/FileUploadModal.vue'
import TableOperations from './components/TableOperations.vue'
import OperationsModal from './components/Operations.vue'
// import filters from '@/components/filters.vue'
import filters from './components/filters.vue'
import qrCodeModal from '../Contracts/components/qrCodeModal.vue'
import showFileModal from '@/components/ShowFileModal.vue'
import checkPermission from '@/mixins/checkPermission'

export default {
  directives: {
    'b-toggle': VBToggle,
  },
  components: {
    BRow,
    BCol,
    TableOperations,
    OperationsModal,
    filters,
    BFormGroup,
    BFormInput,
    BButton,
    BCard,
    showFileModal,
    qrCodeModal,
    FileUploadModal,
  },
  mixins: [checkPermission],

  data() {
    return {
      isSidebar: false,
      pagination: {
        page: 1,
        page_size: 10,
      },
      delay: 200,
      qr_url: '',
      receipt_url: '',
      params: {
        page_size: 10,
        page: 1,
        ordering: null,
        search: null,
      },
      paginationRows: 2,
      operation: null,
      transactionCashbox: {
        results: [],
      },
      clientsList: {
        results: [],
      },
      transactionIncomeType: {
        results: [],
      },
    }
  },
  computed: {
    ...mapGetters('contracts', ['GET_CONTRACTS']),
    ...mapGetters('finance', [
      'GET_TRANSACTIONS',
      'getTransactionIncomeType',
      'getTransactionCashbox',
    ]),
  },
  mounted() {
    this.updateTable()
  },
  methods: {
    ...mapActions('finance', [
      // 'FETCH_TRANSACTION_INCOME_TYPE',
      'FETCH_TRANSACTIONS',
      'UPDATE_TRANSACTIONS',
      'EXPORT_EXCEL',
    ]),
    openFileUploadModal() {
      this.$bvModal.show('file-upload-modal')
    },
    exportExcel() {
      this.EXPORT_EXCEL().then((res) => {
        const url = window.URL.createObjectURL(new Blob([res.data]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', 'Transactions.xlsx')
        document.body.appendChild(link)
        link.click()
      })
      // exportExcel() {
      //   this.FETCH_DEBTS_EXCEL(this.filter_form_query)
      //       .then(() => {
      //         const url = window.URL.createObjectURL(new Blob([res.data]))
      //         const link = document.createElement('a')
      //         link.href = url
      //         link.setAttribute('download', 'file.xlsx')
      //         document.body.appendChild(link)
      //         link.click();
      //       })
    },
    filterChanged(query_params) {
      this.params = {
        ...this.params,
        ...query_params,
      }
      this.params.page = 1
      this.updateTable()
    },
    changePage(pagination) {
      this.params = {
        ...this.params,
        ...pagination,
      }
      this.updateTable()
    },
    showQrCode(url) {
      this.qr_url = url
      this.$bvModal.show('qr-code-modal')
    },
    showClick(url) {
      this.receipt_url = url
      this.$bvModal.show('show-file-modal-lg')
    },
    deleteClick(item_id) {
      this.$_showAreYouSureModal().then((value) => {
        if (value) {
          this.UPDATE_TRANSACTIONS({ id: item_id, is_active: false }).then(
            () => {
              this.updateTable()
            },
          )
        }
      })
    },
    updateTable() {
      this.FETCH_TRANSACTIONS(this.params)
    },
    clearFilter() {
      this.params = {
        page_size: 10,
        page: 1,
        ordering: null,
        search: null,
      }
      this.updateTable()
    },
    // async refresh() {
    //   const res = await this.FETCH_TRANSACTIONS({
    //     ...this.pagination,
    //   })
    //   this.paginationRows = res.count
    // },
    editOperation(data) {
      console.log('data', data)
      this.operation = data
    },
    modalShow() {
      this.operation = null
      this.isSidebar = true
      // this.$bvModal.show('operation-modal')
    },
    delayedFilter() {
      clearTimeout(this.delay)
      this.delay = setTimeout(() => {
        this.filterChanged()
      }, 300)
    },
  },
}
</script>
